import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  SupportCategoryOption,
  SupportTicketChangeAssigneePayload,
  SupportTicketChangeCategoryPayload,
  SupportTicketChangePriorityPayload,
  SupportTicketClosePayload,
  SupportTicketCreatePayload,
  SupportTicketDetail,
  SupportTicketInternalNote,
  SupportTicketListItem,
  SupportTicketListQuery,
  SupportTicketMessage,
  SupportTicketMessagePayload,
  SupportTicketStats,
} from '../models/help-support-tickets';

export const HelpSupportTicketsActions = createActionGroup({
  source: 'Help Support Tickets',
  events: {
    'Load List': props<{ query: SupportTicketListQuery }>(),
    'Load List Success': props<{
      rows: SupportTicketListItem[];
      total: number;
      page: number;
      pageSize: number;
      stats: SupportTicketStats;
    }>(),
    'Load List Failure': props<{ error: string }>(),
    'Load Categories': emptyProps(),
    'Load Categories Success': props<{ categories: SupportCategoryOption[] }>(),
    'Load Categories Failure': props<{ error: string }>(),
    'Load Detail': props<{ ticketId: string }>(),
    'Load Detail Success': props<{ ticket: SupportTicketDetail }>(),
    'Load Detail Failure': props<{ error: string }>(),
    'Create Ticket': props<{ payload: SupportTicketCreatePayload }>(),
    'Create Ticket Success': props<{ ticket: SupportTicketDetail; message: string }>(),
    'Create Ticket Failure': props<{ error: string }>(),
    'Create Message': props<{ ticketId: string; payload: SupportTicketMessagePayload }>(),
    'Create Message Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Create Message Failure': props<{ error: string }>(),
    'Receive Realtime Message': props<{
      ticketId: string;
      message: SupportTicketMessage;
      ticketStatus?: string;
    }>(),
    'Create Internal Note': props<{
      ticketId: string;
      payload: SupportTicketMessagePayload;
    }>(),
    'Create Internal Note Success': props<{
      note: SupportTicketInternalNote;
      toast: string;
    }>(),
    'Create Internal Note Failure': props<{ error: string }>(),
    'Change Assignee': props<{
      ticketId: string;
      payload: SupportTicketChangeAssigneePayload;
    }>(),
    'Change Assignee Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Change Assignee Failure': props<{ error: string }>(),
    'Change Category': props<{
      ticketId: string;
      payload: SupportTicketChangeCategoryPayload;
    }>(),
    'Change Category Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Change Category Failure': props<{ error: string }>(),
    'Change Priority': props<{
      ticketId: string;
      payload: SupportTicketChangePriorityPayload;
    }>(),
    'Change Priority Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Change Priority Failure': props<{ error: string }>(),
    'Assign To Me': props<{ ticketId: string }>(),
    'Assign To Me Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Assign To Me Failure': props<{ error: string }>(),
    'Close Ticket': props<{ ticketId: string; payload: SupportTicketClosePayload }>(),
    'Close Ticket Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Close Ticket Failure': props<{ error: string }>(),
    'Reopen Ticket': props<{ ticketId: string }>(),
    'Reopen Ticket Success': props<{ ticket: SupportTicketDetail; toast: string }>(),
    'Reopen Ticket Failure': props<{ error: string }>(),
    'Clear Error': emptyProps(),
    'Clear Success Message': emptyProps(),
    'Clear Selected Ticket': emptyProps(),
  },
});
